/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2025
 */

import React from 'react';
import { connect } from 'react-redux';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, epuapAttachmentsInfo } from '../utils/utils';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/lib/Button';
import { isMobileView, isTabletView } from '../utils/utils'


const fileBtnStyle = {
  cursor: 'pointer',
  marginLeft: '10px',
  padding: '4px 12px'
}

const fileNameStyle = {
  color: 'red',
  paddingLeft: '0px',
  paddingTop: '5px',
  verticalAlign: 'middle',
  display: 'inline-block',
  maxWidth: '500px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const emptyErrorDict = {
  errorText: null,
  errorTitle: null,
  showError: false,
};

const maxAttachmentsSize = 70.00

class SpecifiedAttachmentsPanel extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    attachments: [],
    total_size: 0.00.toFixed(2),
    fileFormats: [],
    maxAttachSize: 0.00,
    isMounted: false,
    isMobile: false,
    isTablet: false,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    let fileFormats = ['docx', 'pdf', 'jpg', 'zip'];
    if (this.props.formats) {
      fileFormats = this.props.formats;
    }

    const maxAttachSize = this.props.maxSizeMB || maxAttachmentsSize;

    const newState = {
      colors,
      sourceStyle,
      style,
      fileFormats,
      maxAttachSize,
      isMounted: true,
      isMobile: isMobileView(window),
      isTablet: isTabletView(window),
    };

    if (this.props.draftAttachments) {
      newState.attachments = this.props.draftAttachments;
    };

    this.setState(newState, () => this.calculateTotalSize(this.state.attachments, emptyErrorDict));

  }

  addSpecifiedAttachment = (attachment) => {
    this.setState({
      attachments: [...this.state.attachments, {
        name: '',
        extension: '',
        data: '',
        size: 0.00,
        type: attachment
      }],
    }, () => this.calculateTotalSize(this.state.attachments, emptyErrorDict));
  }

  removeSpecifiedAttachment = (type, idx, errorMessDict=null) => {
    let errorMessageDict = emptyErrorDict;

    if (errorMessDict) { errorMessageDict = errorMessDict; }
    if (!this.props.attachmentsDict[type].multiple) {

      const updatedAttachments = this.state.attachments.filter((attachment, index) => {
        if (attachment.type === type) {
          return false;
        }
        return true;
      });

      this.setState({
        attachments: updatedAttachments,
      }, () => this.calculateTotalSize(updatedAttachments, errorMessageDict));
    } else {
      const filteredAttachments = this.state.attachments.filter(att => att.type === type);
      filteredAttachments.splice(idx, 1);
      const otherAttachments = this.state.attachments.filter(att => att.type != type);
      const finalAttachments = [...filteredAttachments, ...otherAttachments];
    
      this.setState({ attachments: finalAttachments }, () =>
        this.calculateTotalSize(finalAttachments, errorMessageDict)
      );
    }
  }

  onSpecifiedAttachmentChange = async (e, idx, type) => {
    const file = e.target.files[0];
    const name = file.name;
    const extension = name.split('.').slice(-1)[0];
    const attachments = [...this.state.attachments];
    // convert bytes to MB
    const size = file.size / 1000000;
    let sizeError = false;
    const sizeErrorDict = {
      errorText: `Maksymalny łączny rozmiar załączników to ${this.state.maxAttachSize}MB!`,
      errorTitle: 'Maksymalny rozmiar załączników przekroczony.',
      showError: true,
    };
    const formats = this.state.fileFormats.join(', ');
    const errorDict = {
      errorText: `Załącznik musi być w formacie ${formats}.`,
      errorTitle: 'Błędny format pliku.',
      showError: true,
    };
    if ((size + parseFloat(this.state.total_size)) > this.state.maxAttachSize) { sizeError = true; }
    if (!sizeError && this.state.fileFormats.includes(extension)) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const data = event.target.result;

        const attachmentList = this.state.attachments.filter(att => att.type === type);
      
        const updatedAttachments = attachmentList.map((attachment, index) => {
          if (index === idx) {
            return { name, extension, data, size, type };
          }
          return attachment;
        });

        const otherAttachments = this.state.attachments.filter(att => att.type != type);
        const finalAttachments = [...updatedAttachments, ...otherAttachments];
      
        this.setState({ attachments: finalAttachments }, () => 
          this.calculateTotalSize(finalAttachments, emptyErrorDict)
        );
      };
    } else if (sizeError) {
      this.removeSpecifiedAttachment(type, idx, sizeErrorDict);
    } else { this.removeSpecifiedAttachment(type, idx, errorDict); }
  }

  calculateTotalSize = (attachments, errorDict) => {
    let totalSize = 0.00;
    for (const attachment of this.state.attachments) {
      totalSize += attachment.size;
    }
    this.setState({ total_size: totalSize.toFixed(2) }, () => this.props.onChangeAttachments(attachments, errorDict));
  }

  renderAttachment = (attachment, idx) => {
    let disabled = false;
    if (!this.props.attachmentsDict[attachment].multiple && this.state.attachments.filter(att => att.type === attachment).length > 0) {
      disabled = true;
    }

    const attachmentList = this.state.attachments.filter(att => att.type === attachment);

    return (
      <div key={`attachment_${attachment}_${idx}`}>
        <Row key={`specifiedAttachment_${attachment}_header`} style={{ margin: '0 0 10px 0', display: 'flex', alignItems: 'center' }}>
          <Col xs={2}>
            <Button
              className="btn btn-success"
              onClick={() => this.addSpecifiedAttachment(attachment)}
              disabled={disabled}
            >
              Dodaj załącznik
            </Button>
          </Col>
          <Col xs={10} style={{ padding: '0 0 0 5px' }}>
            <p style={{ textAlign: 'justify', margin: '0' }}>{this.props.attachmentsDict[attachment].label}</p>
          </Col>
        </Row>
        {this.props.attachmentsDict[attachment].description ? 
          <Row key={`specifiedAttachment_${attachment}_description`} style={{ marginBottom: '20px' }}>
            <Col xs={2}></Col>
            <Col xs={10} style={{ paddingTop: '5px', paddingBottom: '5px', margin: '0', fontStyle: 'italic' }}>
              {this.props.attachmentsDict[attachment].description}
            </Col>
          </Row>
        : null}
        {attachmentList.map((att, i) =>
          <Row key={`specifiedAttachment_${att}${i}`} style={{ margin: '0 0 10px 0', display: 'flex', alignItems: 'center' }}>
            <Col xs={2}>
              <Button
                className="btn btn-default"
                style={fileBtnStyle}
                onClick={() => document.getElementById(`specifiedAttachment_${att.type}_button_${i}`).click()}
              >
                Wybierz plik
              </Button>
            </Col>
            <Col xs={9} style={{ padding: '0 0 0 5px' }}>
              <span style={fileNameStyle}>{att.name ? att.name : 'Nie wybrano pliku'}</span>
              <input id={`specifiedAttachment_${att.type}_button_${i}`} type="file" style={{ color: 'red', width: '100%', display: 'none' }} accept=".pdf,.docx,.jpg,.zip" onChange={(e) => this.onSpecifiedAttachmentChange(e, i, attachment)} />
              
            </Col>
            <Col xs={1} style={{ padding: '0 0 0 5px' }}>
              <Button
                className="btn btn-danger"
                onClick={() => this.removeSpecifiedAttachment(attachment, i)}
              >
                Usuń
              </Button>
            </Col>
          </Row>
        )}
      </div>
    );
  }

  render() {
    const formats = this.state.fileFormats.join(', ');

    return (
      <div style={{ fontSize: `${this.props.fontSize}rem`, clear: 'both' }}>
        <div className="col-mobile" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
          <div className={'grayPanel'} style={this.state.style}>
            <div className="basePanelHeading" style={this.state.style}>Załączniki</div>
            <div className="panel-body grayPanelBody">
              {Object.keys(this.props.attachmentsDict).map((v, i) => {
                {return this.renderAttachment(v, i)}
              })}
              {this.props.additionalText && <p><b>{this.props.additionalText}</b></p>}
              <p><br />Wymagane formaty załączników: <b>{formats}</b>.</p>
              <p>Maksymalny łączny rozmiar załączników: <b>{this.state.maxAttachSize}MB</b>.</p>
              {this.state.attachments.length < 1 ? <p style={{ textAlign: 'center' }}>Aby dodać załącznik, kliknij "Dodaj załącznik"</p> : null}
              <p>Łączny rozmiar załączników: <b>{this.state.total_size}MB</b></p>

              {this.props.showExtraText && epuapAttachmentsInfo}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default connect(mapState)(SpecifiedAttachmentsPanel);



// WEBPACK FOOTER //
// src/components/SpecifiedAttachmentsPanel/SpecifiedAttachmentsPanel.js